import {
  trackKeyGrowthEvent,
  NavigationEvents,
  getPageSource,
} from '@mc/track-event'
import { paths } from '@mc/paths'
import { Button } from '@mc/design-system'
import { useTranslation, withI18nContext } from '@mc/i18n'

import i18nInstance from 'i18n/i18nInstance'

const VariantNavCtaComp = () => {
  const { t } = useTranslation('@mc/next')

  const onClick = () =>
    trackKeyGrowthEvent(NavigationEvents.EVENTS.NAVIGATION_CLICKED, {
      action: 'Browse Category Dropdown:All Categories',
      level: 'primary',
      page_source: getPageSource(),
    })

  return (
    <div className='mc-mx-3 mc-mb-3'>
      <Button
        as='a'
        kind='tertiary'
        fullWidth
        onClick={onClick}
        href={paths.categories}
      >
        {t('nav.cta.viewAllCats')}
      </Button>
    </div>
  )
}
export const ViewAllCatsCta = withI18nContext(i18nInstance)(VariantNavCtaComp)
